<template>
  <div class="sim">
    <header class="nav" :class="{ 'nav--solid': scrolled }">
      <div class="wrap nav__in">
        <a class="nav__brand" href="#top" @click.prevent="go('top')">
          <img src="/static/img/home/logo.png" alt="996传奇盒子" />
          <span>模拟器</span>
        </a>
        <nav class="nav__links">
          <a v-for="l in navs" :key="l.id" :href="'#' + l.id" @click.prevent="go(l.id)">{{ l.text }}</a>
        </nav>
        <div class="nav__dl">
          <span class="nav__soon">Windows 敬请期待</span>
          <span class="nav__soon">macOS 敬请期待</span>
        </div>
      </div>
    </header>

    <!-- 首屏 -->
    <section id="top" class="hero">
      <div class="hero__art"><i class="hero__glow"></i></div>
      <div class="wrap hero__in">
        <div class="hero__copy">
          <p class="hero__kicker"><i></i>Android 15</p>
          <h1>996模拟器</h1>
          <p class="hero__sub">为游戏重新设计的模拟器</p>
          <p class="hero__text">
            自研桌面与运行引擎,采用自适应虚拟化,根据电脑环境选择合适的运行方式。图形指令直通宿主显卡,x86_64 应用原生运行,ARM64 应用由自研翻译层执行。
          </p>
          <div class="hero__cta">
            <span class="btn btn--off">Windows 敬请期待</span>
            <span class="btn btn--off">macOS 敬请期待</span>
            <a class="btn btn--line" href="#tech" @click.prevent="go('tech')">了解技术</a>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="hero__bar">
          <div v-for="p in pillars" :key="p.t" class="pillar">
            <small>{{ p.k }}</small>
            <b>{{ p.t }}</b>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品 -->
    <section id="product" class="sec">
      <div class="wrap">
        <header class="sec__head">
          <small>PRODUCT</small>
          <h2>产品</h2>
          <p>把一台 Android 15 平板运行在电脑里,面向游戏场景做了专门的取舍。</p>
        </header>
        <div class="bento">
          <article v-for="(c, i) in highlights" :key="c.t" class="card" :class="'card--' + (i + 1)">
            <ic :name="c.ic" class="card__ic" />
            <h3>{{ c.t }}</h3>
            <p>{{ c.d }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- 技术 -->
    <section id="tech" class="sec sec--alt">
      <div class="wrap">
        <header class="sec__head">
          <small>TECHNOLOGY</small>
          <h2>技术</h2>
          <p>Rust 负责实例管理与原生输入,C++ 运行引擎承载虚拟机,Android 15 作为客体系统,三者通过明确的原生通道通信。</p>
        </header>

        <!-- 三层架构 -->
        <div class="stack">
          <template v-for="(L, i) in layers">
            <div :key="L.name" class="plate" :class="'plate--' + L.k">
              <div class="plate__name">
                <b>{{ L.name }}</b>
                <span>{{ L.sub }}</span>
              </div>
              <ul class="plate__chips">
                <li v-for="c in L.chips" :key="c">{{ c }}</li>
              </ul>
            </div>
            <div v-if="i < layers.length - 1" :key="'l' + i" class="link">
              <i class="link__line"><u></u></i>
              <span>{{ L.link }}</span>
            </div>
          </template>
        </div>

        <!-- 图形管线 -->
        <h3 class="sub">图形管线</h3>
        <div class="flow">
          <i class="flow__track"><u></u></i>
          <div v-for="p in pipeline" :key="p.t" class="node" :class="{ 'node--host': p.host }">
            <small>{{ p.side }}</small>
            <b>{{ p.t }}</b>
            <span>{{ p.d }}</span>
          </div>
        </div>

        <p class="note">橙色为宿主侧步骤。显示分支使用共享图像,跳过逐帧的 CPU 回读与上传;遇到不支持的格式时保留回退路径。</p>

        <h3 class="sub">ARM64 翻译层如何升级代码</h3>
        <div class="tiers">
          <div class="tier"><small>01</small><b>ARM64 指令</b><span>应用原样运行,无需适配</span></div>
          <i></i>
          <div class="tier"><small>02</small><b>轻量翻译</b><span>快速开始执行,同时自剖析热点</span></div>
          <i></i>
          <div class="tier"><small>03</small><b>热点识别</b><span>反复执行的区域被标记</span></div>
          <i></i>
          <div class="tier tier--hot"><small>04</small><b>优化代码</b><span>运行中替换,其他线程不中断</span></div>
        </div>

        <!-- 技术细节 -->
        <div class="tabs">
          <div class="tabs__nav" role="tablist">
            <button
              v-for="(t, i) in techBlocks"
              :key="t.k"
              role="tab"
              :aria-selected="tab === i"
              :class="{ on: tab === i }"
              @click="tab = i"
            >{{ t.k }}</button>
          </div>
          <p class="tabs__lead">{{ techBlocks[tab].lead }}</p>
          <div class="tabs__grid">
            <article v-for="(p, i) in techBlocks[tab].points" :key="p.t">
              <small>{{ '0' + (i + 1) }}</small>
              <h4>{{ p.t }}</h4>
              <p>{{ p.d }}</p>
            </article>
          </div>
        </div>
      </div>
    </section>

    <!-- 性能 -->
    <section id="perf" class="sec">
      <div class="wrap">
        <header class="sec__head">
          <small>PERFORMANCE</small>
          <h2>性能</h2>
          <p>产品实际采用的策略。每一项都围绕减少拷贝、减少等待、减少常驻开销。</p>
        </header>
        <div class="pf">
          <article v-for="p in perfCards" :key="p.t" class="pf__i">
            <ic :name="p.ic" />
            <h3>{{ p.t }}</h3>
            <b>{{ p.k }}</b>
            <p>{{ p.d }}</p>
          </article>
        </div>
        <p class="callout">
          关于性能数据:同一台机器、同一实例配置、同一负载下才能比较,原始样本需要保留,不用单一综合分数代替具体场景。
          ARM64 翻译层的优化在目标硬件上复测之后才下结论。GPU 兼容档位只改变应用识别到的显卡型号,不会提高帧率。
        </p>
      </div>
    </section>

    <!-- 功能 -->
    <section id="features" class="sec sec--alt">
      <div class="wrap">
        <header class="sec__head">
          <small>FEATURES</small>
          <h2>功能</h2>
          <p>常用功能不依赖 ADB 和命令行,全部走内置原生通道。</p>
        </header>
        <ul class="feat">
          <li v-for="f in features" :key="f.t">
            <ic :name="f.ic" />
            <b>{{ f.t }}</b>
            <span>{{ f.d }}</span>
          </li>
        </ul>
      </div>
    </section>

    <!-- 兼容 -->
    <section id="compat" class="sec">
      <div class="wrap">
        <header class="sec__head">
          <small>COMPATIBILITY</small>
          <h2>兼容</h2>
        </header>
        <div class="two">
          <div class="panel">
            <h3>系统要求</h3>
            <dl class="kv">
              <div v-for="r in requirements" :key="r[0]"><dt>{{ r[0] }}</dt><dd>{{ r[1] }}</dd></div>
            </dl>
          </div>
          <div class="panel">
            <h3>应用兼容范围</h3>
            <dl class="kv">
              <div v-for="c in compat" :key="c.t">
                <dt>{{ c.t }}</dt>
                <dd><em :class="c.k">{{ c.k === 'ok' ? '支持' : '限制' }}</em>{{ c.d }}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>

    <!-- 敬请期待 -->
    <section id="download" class="soon">
      <div class="soon__art"></div>
      <div class="wrap soon__in">
        <small>COMING SOON</small>
        <h2>下载</h2>
        <p>996模拟器正在准备发布,请稍候。</p>
        <div class="soon__btns">
          <span class="btn btn--off">Windows 敬请期待</span>
          <span class="btn btn--off">macOS 敬请期待</span>
        </div>
      </div>
    </section>

    <!-- FAQ -->
    <section id="faq" class="sec">
      <div class="wrap wrap--narrow">
        <header class="sec__head">
          <small>FAQ</small>
          <h2>常见问题</h2>
        </header>
        <div class="faq">
          <details v-for="(q, i) in faqs" :key="q.q" :open="i === 0">
            <summary>{{ q.q }}</summary>
            <p>{{ q.a }}</p>
          </details>
        </div>
      </div>
    </section>

    <footer class="foot">
      <div class="wrap foot__in">
        <img src="/static/img/home/logo.png" alt="996传奇盒子" />
        <p>996模拟器</p>
        <p class="foot__small">Android 是 Google LLC 的商标。文中涉及的第三方名称仅用于说明技术来源。</p>
      </div>
    </footer>
  </div>
</template>

<script>
// 线条图标(24x24 网格,描边)
const ICONS = {
  android: ["M6 17V9a6 6 0 0 1 12 0v8z", "M9 5 7.5 3M15 5l1.5-2", "M9.5 10h.01M14.5 10h.01", "M6 17v3h2v-3M16 17v3h2v-3"],
  chip: ["M7 7h10v10H7z", "M9 3v4M15 3v4M9 17v4M15 17v4M3 9h4M3 15h4M17 9h4M17 15h4"],
  layers: ["M12 3 3 8l9 5 9-5-9-5z", "M3 13l9 5 9-5", "M3 17.5l9 5 9-5"],
  swap: ["M7 7h13l-4-4", "M17 17H4l4 4"],
  gamepad: [
    "M6 11h4M8 9v4M15 12h.01M18 10h.01",
    "M17.3 5H6.7a4 4 0 0 0-3.9 3.2l-1.3 6A3.5 3.5 0 0 0 5 18.5l2-2h10l2 2a3.5 3.5 0 0 0 3.5-4.3l-1.3-6A4 4 0 0 0 17.3 5z",
  ],
  memory: ["M3 7h18v10H3z", "M7 11v2M11 11v2M15 11v2M7 21v-4M12 21v-4M17 21v-4"],
  link: ["M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1", "M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"],
  clock: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "M12 7v5l3 2"],
  monitor: ["M3 4h18v12H3z", "M8 20h8", "M12 16v4"],
  sliders: ["M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0", "M16 4v4M10 10v4M18 16v4"],
  pkg: ["M21 8l-9-5-9 5v8l9 5 9-5V8z", "M3.3 7.5 12 12l8.7-4.5", "M12 12v9"],
  pin: ["M12 21s7-6.2 7-11a7 7 0 0 0-14 0c0 4.8 7 11 7 11z", "M12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"],
  terminal: ["M3 5h18v14H3z", "M7 10l3 2-3 2", "M12 15h4"],
  phone: ["M8 2h8a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z", "M11 18h2"],
  camera: ["M3 8h4l2-3h6l2 3h4v12H3z", "M12 17a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"],
  battery: ["M2 8h16v8H2z", "M21 11v2"],
  globe: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "M3 12h18", "M12 3c3 3 3 15 0 18", "M12 3c-3 3-3 15 0 18"],
  mouse: ["M12 2a6 6 0 0 0-6 6v8a6 6 0 0 0 12 0V8a6 6 0 0 0-6-6z", "M12 6v4"],
  refresh: ["M20 11a8 8 0 0 0-14.5-3.5L4 9", "M4 4v5h5", "M4 13a8 8 0 0 0 14.5 3.5L20 15", "M20 20v-5h-5"],
  brush: ["M4 20c3 0 5-1 5-4a3 3 0 0 0-3-3c-2 0-2 3-3 7z", "M9 13l9-9 3 3-9 9"],
  rocket: ["M5 15c-1 1-2 4-2 6 2 0 5-1 6-2", "M9 15 5 11c1-4 4-7 9-8 3-.5 5-.3 7-.3 0 2 .2 4-.3 7-1 5-4 8-8 9l-4-3.7z", "M15 9h.01"],
  bolt: ["M13 2 4 14h7l-1 8 9-12h-7l1-8z"],
};

const IcComp = {
  name: "Ic",
  functional: true,
  props: { name: String },
  render(h, ctx) {
    const paths = ICONS[ctx.props.name] || [];
    return h(
      "svg",
      {
        class: ["ic", ctx.data.staticClass, ctx.data.class],
        attrs: {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": 1.5,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true",
        },
      },
      paths.map((d) => h("path", { attrs: { d } })),
    );
  },
};

export default {
  name: "SimOfficial",
  components: { Ic: IcComp },
  data() {
    return {
      scrolled: false,
      tab: 0,
      navs: [
        { id: "product", text: "产品" },
        { id: "tech", text: "技术" },
        { id: "perf", text: "性能" },
        { id: "features", text: "功能" },
        { id: "compat", text: "兼容" },
        { id: "faq", text: "常见问题" },
      ],
      pillars: [
        { k: "系统", t: "Android 15 · API 35" },
        { k: "虚拟化", t: "自适应虚拟化" },
        { k: "图形", t: "GLES 3.2 / Vulkan 直通" },
        { k: "架构", t: "x86_64 原生 + ARM64" },
      ],
      highlights: [
        { ic: "android", t: "Android 15", d: "API 35、64 位系统。桌面基于 Lawnchair,内置 Trichrome WebView 与自研输入法。" },
        { ic: "chip", t: "自适应虚拟化", d: "根据电脑的虚拟化环境自动选择运行方式,与 Hyper-V、WSL2 共存,不要求关闭 Hyper-V。启动前检测环境,缺少的组件可一键开启。" },
        { ic: "layers", t: "图形直通", d: "客体图形指令经 gfxstream 编码,由宿主解码后交给 ANGLE 的 Vulkan 后端执行,画面以 Win32 共享图像送到原生窗口,不经过逐帧的 CPU 回读。" },
        { ic: "swap", t: "x86_64 与 ARM64", d: "系统与 x86_64 应用原生运行,ARM64 应用由自研翻译层动态翻译,热点代码分级编译。对外同时公布 x86_64 与 arm64-v8a。" },
        { ic: "gamepad", t: "键鼠与手柄映射", d: "拖拽式映射编辑器,支持摇杆、方向盘、瞄准与开火工具;按应用和输入设备分别记住方案。" },
        { ic: "memory", t: "克制的内存策略", d: "文件缓存设软限额,匿名页使用磁盘交换,关闭后台内存整理,让实例占用更少、表现更平稳。" },
        { ic: "link", t: "原生控制通道", d: "安装 APK、虚拟定位、终端、刷新率等操作走绑定启动代次的原生通道,不回退到 ADB。ADB 仅作为可选的调试入口。" },
      ],
      layers: [
        {
          k: "host",
          name: "Windows 宿主",
          sub: "Rust · Slint",
          link: "进程内调用",
          chips: ["实例管理", "Slint 桌面界面", "键鼠 / 手柄原生输入", "WebView2(地图、终端)", "在线更新"],
        },
        {
          k: "engine",
          name: "运行引擎",
          sub: "C++ · VirtualBox VMM",
          link: "VAddress 共享环 · PDM 设备 · NativeControl 原生控制通道",
          chips: ["WHP 原生 x2APIC", "BIOS / GRUB 引导", "gfxstream 解码 + ANGLE Vulkan", "VirtIO-SCSI 数据盘", "NAT / libslirp 网络", "WinMM 音频隧道"],
        },
        {
          k: "guest",
          name: "Android 15 客体",
          sub: "API 35 · Linux 6.6",
          chips: ["Lawnchair 桌面", "Trichrome WebView", "Sim996IME 输入法", "ARM64 翻译层", "gfxstream 编码", "system_server 原生控制服务"],
        },
      ],
      pipeline: [
        { side: "客体", t: "游戏", d: "GLES 3.2 / Vulkan", host: false },
        { side: "客体", t: "gfxstream 编码", d: "图形指令序列化", host: false },
        { side: "桥接", t: "VAddress 共享环", d: "稀疏地址窗口", host: false },
        { side: "宿主", t: "gfxstream 解码", d: "还原指令与状态", host: true },
        { side: "宿主", t: "ANGLE → Vulkan", d: "在宿主显卡上执行", host: true },
        { side: "宿主", t: "Win32 共享图像", d: "GPU timeline 同步", host: true },
        { side: "宿主", t: "原生窗口", d: "同进程 HWND 呈现", host: true },
      ],
      techBlocks: [
        {
          k: "虚拟化",
          lead: "基于 VirtualBox VMM 定制,以 WHP 作为硬件加速后端。",
          points: [
            { t: "原生 x2APIC", d: "IPI、TPR、EOI 与 LAPIC 定时器由 WHP 直接执行,外设中断经 WHvRequestInterrupt 注入。能力不足时明确拒绝启动,不会静默退化为软件模拟。" },
            { t: "启动前体检", d: "依次检查系统版本、hypervisor 是否存在、APIC 虚拟化能力。缺失时提示在 BIOS 开启 VT-x / AMD-V,或经 UAC 一键开启虚拟机监控程序平台。" },
            { t: "BIOS / GRUB 引导", d: "System MBR 链式引导 metadata 上的 GRUB,按签名扫描启动盘,不依赖固定盘号。引导区原子更新,内容未变则不重写。" },
            { t: "动态数据盘", d: "首次启动自动创建未加密的动态 VDI,按实际占用增长,使用宿主文件缓存与 discard。" },
            { t: "实例隔离", d: "配置、磁盘、运行状态、日志与 WebView 数据分目录存放。同一实例只运行一份,重复启动会唤回已有窗口。" },
          ],
        },
        {
          k: "图形",
          lead: "整条链路以减少拷贝和等待为目标。",
          points: [
            { t: "gfxstream + ANGLE", d: "GLES 应用走 gfxstream GLES 编码,再由源码构建的 ANGLE 以 Vulkan 执行。原生 Vulkan 应用直接使用 gfxstream Vulkan 编码。" },
            { t: "共享图像显示", d: "宿主 Vulkan 与 ANGLE 在同一物理设备上导入 Win32 共享图像,用 GPU timeline 交换所有权。" },
            { t: "GLES 3.2", d: "覆盖几何与细分着色器、base-vertex、indexed blend、纹理复制、数组纹理、texture buffer 等。压缩纹理保留原始压缩块的位语义。" },
            { t: "地址空间", d: "VAddress 提供稀疏 PCI 地址空间,同时容纳传输环与 Vulkan 共享内存分配,并按进程与用户限制配额。这是地址空间容量,不是启动时预占的物理内存。" },
            { t: "GPU 兼容档位", d: "可让应用识别为 Adreno 530 / 640 / 740,或保持原生。它影响游戏对机型的判断与资源选择,实际渲染仍由电脑显卡完成。" },
          ],
        },
        {
          k: "ARM64 翻译",
          lead: "内核与系统是 x86_64,ARM64 应用通过自研翻译层执行。",
          points: [
            { t: "分级编译", d: "代码先以轻量翻译执行并自剖析,热点区域升级为优化代码。升级期间其他线程可继续运行,发生代码失效时安全撤销并刷新缓存。" },
            { t: "标志位与比较", d: "复用比较操作数与宿主 FLAGS,延迟 NZCV 打包,只在需要的出口还原完整状态。覆盖 32 / 64 位 CMP、SUBS 与 14 种条件。" },
            { t: "寄存器与冗余复制", d: "在寄存器分配前后做状态槽复用、冗余复制删除与高 32 位为零的证明,并保留每个访存故障点与信号出口的完整 guest 状态。" },
            { t: "SIMD 与加密", d: "SIMD 成对加载保持故障原子性。宿主支持 AES-NI 时,相邻的 AESE 与 AESMC 融合为一次 AESENC。" },
            { t: "架构信息一致", d: "产品内核让 uname、libc 与直接系统调用统一返回 aarch64,避免应用因架构信息不一致而误判。" },
          ],
        },
        {
          k: "输入 · 音频 · 网络",
          lead: "每类外设使用独立通道。",
          points: [
            { t: "输入通道", d: "触控、键盘、鼠标悬停分别走专用通道。键盘使用命名共享内存环,拥塞超时会销毁客体设备,避免丢失释放事件造成卡键。" },
            { t: "输入法", d: "Windows 输入法组词期间按键不会误发给安卓。文字经 Sim996IME 直接提交到当前输入框,密码框内容不回传。" },
            { t: "鼠标滚轮", d: "滚轮转换为连续的触摸手势,与拖拽、触屏和按键映射共用同一触摸路径。" },
            { t: "音频", d: "双向 PCM 经 VAddress 送入 WinMM waveOut / waveIn,支持播放与录音。" },
            { t: "网络", d: "NAT 出口遵循 Windows 路由(包括 VPN / TUN),DNS 自动读取宿主列表。内核采用 Westwood 拥塞控制与 fq_pie 队列。" },
          ],
        },
      ],
      perfCards: [
        { ic: "rocket", t: "启动", k: "复用引导镜像", d: "再次启动只读取必要的引导区,内容不变则不重写。启动遮罩显示真实阶段,按历史耗时估算进度,波动大时不显示虚构的百分比。" },
        { ic: "layers", t: "渲染", k: "GPU 直通", d: "共享图像加 GPU timeline,显示分支跳过逐帧 CPU 回读。GLES 3.2 与 Vulkan 双栈,可选 NVIDIA 高性能模式。" },
        { ic: "monitor", t: "刷新率", k: "跟随显示器", d: "垂直同步开启时跟随窗口所在显示器的当前信号频率,换屏后自动重新匹配,上限可调整。可开启非操作窗口自动降帧。" },
        { ic: "chip", t: "CPU 与内存", k: "自动推荐", d: "新实例按电脑配置推荐虚拟 CPU 与内存,不会超过电脑本身的能力,之后以你的设置为准,可随时调整。" },
        { ic: "memory", t: "内存回收", k: "软限额 + 磁盘交换", d: "文件缓存按需后台回收,不为凑目标同步写回脏页;匿名页使用磁盘交换,不启用 zram / zswap;保留 cached-app freezer 与 LMKD。" },
        { ic: "swap", t: "ARM64 翻译", k: "分级编译", d: "热点区域运行中升级为优化代码,升级期间其他线程不中断,每项优化都保留精确的故障与信号语义。" },
      ],
      features: [
        { ic: "gamepad", t: "键鼠 / 手柄映射", d: "拖拽放置键位,支持撤销重做;为每个应用和输入设备分别记住方案。" },
        { ic: "pkg", t: "拖拽安装 APK", d: "把 APK 拖进窗口即可安装,桌面显示带进度的安装图标,不经过 ADB。" },
        { ic: "pin", t: "虚拟定位", d: "内置高德地图窗口,支持搜索、点选、拖动图钉微调,也可手动输入坐标。" },
        { ic: "terminal", t: "安卓终端", d: "离线 xterm 终端,支持 UTF-8、256 色与 Ctrl+C,不依赖 ADB 或 SSH。" },
        { ic: "phone", t: "机型库", d: "多品牌手机与平板机型预设,可自定义品牌与型号;可设置手机号与 IMEI。" },
        { ic: "camera", t: "摄像头", d: "前后双摄,多档分辨率。没有摄像头时提供虚拟画面,用于接口测试。" },
        { ic: "battery", t: "电池与传感器", d: "笔记本同步真实电量与充电状态。姿态随屏幕方向自动同步,也可手动设置设备角度。" },
        { ic: "globe", t: "Google 框架安装", d: "桌面自带安装器,按固定顺序安装 GSF、GMS 与 Play 商店,逐个校验安装结果。" },
        { ic: "monitor", t: "窗口与显示", d: "自由缩放并保持画面比例,多档分辨率与 DPI,支持后台自动降帧与应用保活。" },
        { ic: "mouse", t: "鼠标", d: "支持悬停、滚轮与拖拽,并提供为射击游戏准备的瞄准与开火工具。" },
        { ic: "refresh", t: "在线更新", d: "客户端检查更新并展示更新日志,由你决定是否更新。更新包经 SHA-256 校验。" },
        { ic: "brush", t: "外观", d: "跟随系统深浅色与强调色,Windows 11 下使用亚克力材质,设置页支持搜索。" },
      ],
      requirements: [
        ["操作系统", "Windows 10 1903(内部版本 18362)及以上,推荐 Windows 11"],
        ["处理器", "支持 Intel VT-x / AMD-V,并已在 BIOS / UEFI 中开启"],
        ["虚拟化组件", "Windows 虚拟机监控程序平台。首次启动自动检测,可一键开启,需要 UAC,可能需要重启"],
        ["显卡", "支持 Vulkan 的显卡,建议使用最新驱动"],
        ["内存", "按电脑内存自动推荐分配给安卓的容量,可手动调整"],
        ["磁盘", "数据盘动态分配,按实际使用量增长"],
        ["可选组件", "系统 WebView2。仅在使用地图定位与终端时需要,缺失时会提示安装"],
      ],
      compat: [
        { k: "ok", t: "x86_64 应用", d: "原生运行。" },
        { k: "ok", t: "ARM64 应用", d: "arm64-v8a,由自研翻译层自动翻译。" },
        { k: "ok", t: "GLES 3.2 / Vulkan", d: "经 gfxstream 与 ANGLE 在宿主显卡上执行。" },
        { k: "warn", t: "仅含 ARM32 库的应用", d: "暂不支持。" },
        { k: "warn", t: "通话与短信", d: "为本地模拟,不能连接真实运营商。" },
        { k: "warn", t: "个别图形特性", d: "依赖持久缓冲区映射(GL_EXT_buffer_storage)的应用可能受限。" },
      ],
      faqs: [
        { q: "需要关闭 Hyper-V 或内存完整性吗?", a: "不需要。996模拟器运行在 Windows 自带的虚拟机监控程序平台(WHP)之上,与 Hyper-V、WSL2 使用同一个 hypervisor。你只需要在 BIOS 中开启 VT-x / AMD-V。" },
        { q: "支持 ARM 版游戏吗?", a: "支持。系统本身是 x86_64,ARM64(arm64-v8a)应用会通过自研翻译层自动翻译执行。目前只含 ARM32 原生库的应用暂不支持。" },
        { q: "怎么安装 APK?", a: "把 APK 直接拖进模拟器窗口,松开鼠标即开始安装;也可以点击右上角的“安装 APK”选择文件。安装过程不使用 ADB,桌面会出现带进度的图标。" },
        { q: "能用 Google Play 吗?", a: "桌面自带“Google 框架一键安装”入口,点击后依次安装 GSF、GMS 与 Play 商店,并逐个校验结果。是否包含该安装包取决于所下载的版本。" },
        { q: "需要开启 ADB 吗?", a: "日常使用不需要。安装、定位、终端、刷新率等功能都走内置原生通道。ADB 仅作为可选的调试入口,在“设置 → 开发者”中配置,默认只监听本机 127.0.0.1。" },
        { q: "虚拟定位会被游戏识别吗?", a: "虚拟定位基于 Android 的测试定位提供器,并保留系统的“模拟位置”标志,部分应用可能识别或拒绝模拟定位。它不会修改真实 IP、Wi-Fi 或基站信息。" },
        { q: "数据存放在哪里?怎么迁移?", a: "默认位于 %LOCALAPPDATA%\\996BoxSimulator\\instances\\default。在设置的“磁盘”页选择一个空文件夹即可更换位置,并可选择是否迁移现有应用、游戏与设置。" },
        { q: "怎么更新?", a: "客户端会检查发布渠道,发现新版本时展示更新日志,由你选择是否更新。更新包经 SHA-256 校验,校验失败的下载会被丢弃。" },
      ],
    };
  },
  created() {
    this._title = document.title;
    document.title = "996模拟器";
  },
  mounted() {
    this.onScroll();
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.$nextTick(this.initReveal);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    if (this._io) this._io.disconnect();
    if (this._title) document.title = this._title;
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 40;
    },
    go(id) {
      const el = document.getElementById(id);
      if (!el) return;
      const y = id === "top" ? 0 : el.getBoundingClientRect().top + window.scrollY - 60;
      window.scrollTo({ top: y, behavior: "smooth" });
    },
    // 轻量入场:元素进入视口时上浮淡入;不支持或偏好减少动效时直接显示
    initReveal() {
      if (!("IntersectionObserver" in window)) return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      const els = Array.from(
        this.$el.querySelectorAll(".sec__head, .card, .plate, .node, .tier, .tabs, .pf__i, .feat li, .panel, .faq details"),
      );
      els.forEach((el) => el.classList.add("rv"));
      this._io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("rv--in");
              this._io.unobserve(e.target);
            }
          });
        },
        { rootMargin: "0px 0px -6% 0px", threshold: 0.05 },
      );
      els.forEach((el) => this._io.observe(el));
    },
  },
};
</script>

<!-- 基础重置单独放在非 scoped 块:优先级低于组件内的单类选择器,否则会盖掉各处的 margin -->
<style lang="less">
.sim {
  h1,
  h2,
  h3,
  h4,
  p,
  ul,
  ol,
  dl,
  dd,
  dt,
  table {
    margin: 0;
    padding: 0;
  }
  ul,
  ol {
    list-style: none;
  }
}
</style>

<style lang="less" scoped>
.sim {
  --bg: #0b0f10;
  --bg-2: #0f1517;
  --card: #131a1c;
  --card-2: #172023;
  --line: rgba(255, 255, 255, 0.08);
  --line-2: rgba(255, 255, 255, 0.16);
  --ink: #eef1f1;
  --ink-2: #a9b3b5;
  --ink-3: #6f7b7e;
  --ac: #ffa21f;
  --ac-2: #ffc85a;
  --ac-dim: rgba(255, 162, 31, 0.14);

  min-height: 100vh;
  background: var(--bg);
  color: var(--ink);
  font-family: "Microsoft YaHei", "PingFang SC", -apple-system, "Segoe UI", Arial, sans-serif;
  font-size: 15px;
  line-height: 1.75;
  text-align: left;
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;

  * {
    box-sizing: border-box;
    // 全站 reset.css 给元素写死了 "Microsoft YaHei",非 Windows 会回退成衬线体
    font-family: inherit;
  }
  // reset.css 给 th/td/button 写死了 #666
  th,
  td,
  button {
    color: inherit;
  }
  em,
  i,
  u {
    font-style: normal;
    text-decoration: none;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
}

.wrap {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 28px;
  &--narrow {
    max-width: 860px;
  }
}
.ic {
  width: 1.2em;
  height: 1.2em;
  flex: none;
}

/* ---------- 头部:首屏透明,滚动后与官网一致的深灰底 ---------- */
.nav {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 30;
  transition: background 0.3s, box-shadow 0.3s;
  background: linear-gradient(180deg, rgba(11, 15, 16, 0.7), transparent);
  &--solid {
    background: #242424;
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.06);
  }
  &__in {
    height: 64px;
    display: flex;
    align-items: center;
  }
  &__brand {
    display: flex;
    align-items: center;
    img {
      height: 28px;
      width: auto;
      display: block;
    }
    span {
      margin-left: 14px;
      padding-left: 14px;
      border-left: 1px solid rgba(255, 255, 255, 0.28);
      color: #fff;
      font-size: 16px;
    }
  }
  &__links {
    display: flex;
    margin-left: auto;
    a {
      position: relative;
      padding: 0 16px;
      line-height: 64px;
      color: #c4cccd;
      font-size: 14px;
      transition: color 0.2s;
      &::after {
        content: "";
        position: absolute;
        left: 16px;
        right: 16px;
        bottom: 14px;
        height: 2px;
        background: var(--ac);
        transform: scaleX(0);
        transition: transform 0.25s;
      }
      &:hover {
        color: #fff;
        &::after {
          transform: scaleX(1);
        }
      }
    }
  }
  &__dl {
    display: flex;
    gap: 8px;
    margin-left: 12px;
  }
  &__soon {
    padding: 4px 14px;
    border: 1px solid rgba(255, 255, 255, 0.32);
    border-radius: 3px;
    color: #d6dcdd;
    font-size: 13px;
    line-height: 1.5;
  }
}

/* ---------- 按钮 ---------- */
.btn {
  display: inline-block;
  min-width: 140px;
  padding: 12px 28px;
  border-radius: 3px;
  font-size: 15px;
  text-align: center;
  line-height: 1.5;
  transition: border-color 0.2s, background 0.2s;
  &--off {
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #d6dcdd;
    cursor: default;
    user-select: none;
  }
  &--line {
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: #fff;
    &:hover {
      border-color: var(--ac);
      color: var(--ac-2);
    }
  }
}

/* ---------- 首屏 ---------- */
.hero {
  position: relative;
  min-height: 100vh;
  min-height: ~"max(100vh, 700px)";
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--bg);
  &__art {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 82%;
    background: url("/static/img/sim/hero.jpg") 58% 50% / cover no-repeat;
    -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 42%), linear-gradient(0deg, transparent 0, #000 26%);
    -webkit-mask-composite: source-in;
    mask-image: linear-gradient(90deg, transparent 0, #000 42%), linear-gradient(0deg, transparent 0, #000 26%);
    mask-composite: intersect;
    animation: drift 24s ease-in-out infinite alternate;
  }
  // 盒子的呼吸光,位置对应图中发光体
  &__glow {
    position: absolute;
    left: 56%;
    top: 40%;
    width: 360px;
    height: 360px;
    margin: -180px 0 0 -180px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 162, 31, 0.32), transparent 66%);
    mix-blend-mode: screen;
    animation: breathe 5s ease-in-out infinite;
  }
  &__in {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    padding-top: 110px;
    padding-bottom: 40px;
  }
  &__copy {
    max-width: 560px;
  }
  &__kicker {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--ac-2);
    font-size: 14px;
    letter-spacing: 2px;
    i {
      width: 28px;
      height: 2px;
      background: var(--ac);
    }
  }
  h1 {
    margin-top: 16px;
    font-size: 68px;
    line-height: 1.1;
    font-weight: 700;
    letter-spacing: 2px;
  }
  &__sub {
    margin-top: 14px;
    font-size: 24px;
    color: #e4e9e9;
  }
  &__text {
    margin-top: 22px;
    color: var(--ink-2);
    font-size: 15.5px;
  }
  &__cta {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 40px;
  }
  &__bar {
    position: relative;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 36px;
    border: 1px solid var(--line-2);
    background: rgba(11, 15, 16, 0.55);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    padding: 0;
  }
}
.pillar {
  padding: 18px 24px;
  & + & {
    border-left: 1px solid var(--line);
  }
  small {
    display: block;
    color: var(--ac-2);
    font-size: 12px;
    letter-spacing: 2px;
  }
  b {
    display: block;
    margin-top: 2px;
    font-size: 16px;
    font-weight: 600;
  }
}
@keyframes drift {
  from {
    transform: scale(1.06) translateX(1%);
  }
  to {
    transform: scale(1) translateX(0);
  }
}
@keyframes breathe {
  0%,
  100% {
    opacity: 0.45;
    transform: scale(0.92);
  }
  50% {
    opacity: 1;
    transform: scale(1.06);
  }
}

/* ---------- 章节 ---------- */
.sec {
  padding: 112px 0;
  &--alt {
    background: var(--bg-2);
    border-top: 1px solid var(--line);
    border-bottom: 1px solid var(--line);
  }
  &__head {
    margin-bottom: 56px;
    small {
      display: block;
      color: var(--ac);
      font-size: 12px;
      letter-spacing: 4px;
    }
    h2 {
      margin-top: 6px;
      font-size: 38px;
      line-height: 1.25;
      font-weight: 700;
    }
    p {
      margin-top: 12px;
      max-width: 700px;
      color: var(--ink-2);
    }
  }
}
.sub {
  margin: 72px 0 20px;
  padding-left: 14px;
  border-left: 3px solid var(--ac);
  font-size: 19px;
  font-weight: 700;
  line-height: 1.3;
}
.note {
  margin-top: 14px;
  color: var(--ink-3);
  font-size: 13px;
}

/* 角标:盒子的转角记号,用在卡片上 */
.card,
.pf__i,
.panel,
.feat li {
  position: relative;
  background: var(--card);
  border: 1px solid var(--line);
  transition: border-color 0.25s, background 0.25s, transform 0.25s;
  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    border: 0 solid var(--ac);
    opacity: 0.55;
    transition: opacity 0.25s, width 0.25s, height 0.25s;
  }
  &::before {
    top: -1px;
    left: -1px;
    border-width: 2px 0 0 2px;
  }
  &::after {
    right: -1px;
    bottom: -1px;
    border-width: 0 2px 2px 0;
  }
  &:hover {
    border-color: var(--line-2);
    background: var(--card-2);
    &::before,
    &::after {
      opacity: 1;
      width: 18px;
      height: 18px;
    }
  }
}

/* 产品 bento */
.bento {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
}
.card {
  padding: 30px 30px 32px;
  &--1 {
    grid-column: span 5;
  }
  &--2 {
    grid-column: span 7;
  }
  &--3 {
    grid-column: span 7;
  }
  &--4 {
    grid-column: span 5;
  }
  &--5,
  &--6,
  &--7 {
    grid-column: span 4;
  }
  &__ic {
    width: 34px;
    height: 34px;
    color: var(--ac);
  }
  h3 {
    margin-top: 22px;
    font-size: 20px;
  }
  p {
    margin-top: 8px;
    color: var(--ink-2);
    font-size: 14.5px;
  }
}

/* 架构分层 */
.stack {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.plate {
  display: grid;
  grid-template-columns: 240px 1fr;
  align-items: center;
  gap: 24px;
  padding: 24px 28px;
  background: var(--card);
  border: 1px solid var(--line-2);
  border-left-width: 3px;
  &--host {
    border-left-color: #6fa8b3;
  }
  &--engine {
    border-left-color: var(--ac);
    background: linear-gradient(90deg, rgba(255, 162, 31, 0.08), var(--card) 60%);
  }
  &--guest {
    border-left-color: #7fbf8f;
  }
  &__name {
    b {
      display: block;
      font-size: 18px;
    }
    span {
      color: var(--ink-3);
      font-size: 13px;
    }
  }
  &__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    li {
      padding: 4px 12px;
      font-size: 13.5px;
      color: var(--ink-2);
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid var(--line);
    }
  }
}
.link {
  position: relative;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    position: relative;
    padding: 3px 14px;
    color: var(--ink-2);
    font-size: 12.5px;
    background: var(--bg-2);
    border: 1px dashed var(--line-2);
  }
  &__line {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 1px;
    background: var(--line-2);
    u {
      position: absolute;
      left: -2px;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: var(--ac);
      box-shadow: 0 0 10px var(--ac);
      animation: down 2.4s linear infinite;
    }
  }
}
@keyframes down {
  from {
    top: 0;
    opacity: 0;
  }
  15%,
  85% {
    opacity: 1;
  }
  to {
    top: 100%;
    opacity: 0;
  }
}

/* 图形管线 */
.flow {
  position: relative;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  &__track {
    position: absolute;
    left: 6%;
    right: 6%;
    top: 22px;
    height: 1px;
    background: var(--line-2);
    u {
      position: absolute;
      top: -2px;
      width: 40px;
      height: 5px;
      border-radius: 3px;
      background: linear-gradient(90deg, transparent, var(--ac));
      box-shadow: 0 0 12px var(--ac);
      animation: across 3.6s linear infinite;
    }
  }
}
.node {
  position: relative;
  padding: 36px 12px 16px;
  background: var(--card);
  border: 1px solid var(--line);
  &::before {
    content: "";
    position: absolute;
    top: 17px;
    left: 14px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: var(--bg-2);
    border: 2px solid #5b6a6d;
  }
  small {
    position: absolute;
    top: 14px;
    right: 12px;
    color: var(--ink-3);
    font-size: 12px;
  }
  b {
    display: block;
    font-size: 14px;
    line-height: 1.4;
  }
  span {
    display: block;
    margin-top: 2px;
    color: var(--ink-2);
    font-size: 12.5px;
    line-height: 1.5;
  }
  &--host {
    border-color: rgba(255, 162, 31, 0.3);
    background: linear-gradient(180deg, rgba(255, 162, 31, 0.07), var(--card));
    &::before {
      border-color: var(--ac);
      background: var(--ac);
    }
  }
}
@keyframes across {
  from {
    left: 0;
  }
  to {
    left: calc(100% - 40px);
  }
}

/* 翻译分级 */
.tiers {
  display: flex;
  align-items: stretch;
  gap: 10px;
  > i {
    align-self: center;
    flex: none;
    width: 26px;
    height: 1px;
    background: var(--line-2);
    position: relative;
    &::after {
      content: "";
      position: absolute;
      right: 0;
      top: -3px;
      border: 3.5px solid transparent;
      border-left: 6px solid var(--ink-3);
      border-right: 0;
    }
  }
}
.tier {
  flex: 1;
  padding: 18px 20px;
  background: var(--card);
  border: 1px solid var(--line);
  small {
    color: var(--ink-3);
    font-size: 12px;
    letter-spacing: 2px;
  }
  b {
    display: block;
    margin-top: 2px;
    font-size: 16px;
  }
  span {
    display: block;
    margin-top: 4px;
    color: var(--ink-2);
    font-size: 13px;
    line-height: 1.6;
  }
  &--hot {
    border-color: rgba(255, 162, 31, 0.45);
    background: linear-gradient(180deg, rgba(255, 162, 31, 0.1), var(--card));
    small {
      color: var(--ac);
    }
  }
}

/* 技术细节标签页 */
.tabs {
  margin-top: 72px;
  &__nav {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid var(--line-2);
    button {
      position: relative;
      padding: 14px 26px;
      color: var(--ink-2);
      font-size: 15px;
      background: none;
      border: 0;
      cursor: pointer;
      transition: color 0.2s;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -1px;
        height: 2px;
        background: var(--ac);
        transform: scaleX(0);
        transition: transform 0.25s;
      }
      &:hover {
        color: #fff;
      }
      &.on {
        color: var(--ac-2);
        &::after {
          transform: scaleX(1);
        }
      }
    }
  }
  &__lead {
    margin: 24px 0 20px;
    color: var(--ink-2);
  }
  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    article {
      padding: 22px 22px 24px;
      background: var(--card);
      border: 1px solid var(--line);
      small {
        color: var(--ac);
        font-size: 13px;
        letter-spacing: 2px;
      }
      h4 {
        margin-top: 4px;
        font-size: 16px;
      }
      p {
        margin-top: 6px;
        color: var(--ink-2);
        font-size: 13.5px;
        line-height: 1.7;
      }
    }
  }
}

/* 性能 */
.pf {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  &__i {
    padding: 28px;
    .ic {
      width: 30px;
      height: 30px;
      color: var(--ac);
    }
    h3 {
      margin-top: 18px;
      color: var(--ink-3);
      font-size: 13px;
      font-weight: 400;
      letter-spacing: 2px;
    }
    b {
      display: block;
      margin-top: 2px;
      font-size: 22px;
      line-height: 1.35;
    }
    p {
      margin-top: 10px;
      color: var(--ink-2);
      font-size: 14px;
    }
  }
}
.callout {
  margin-top: 28px;
  padding: 18px 22px;
  border-left: 3px solid var(--ac);
  background: var(--card);
  color: var(--ink-2);
  font-size: 14px;
}

/* 功能 */
.feat {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  li {
    padding: 24px 22px 26px;
    .ic {
      width: 26px;
      height: 26px;
      color: var(--ac);
    }
    b {
      display: block;
      margin-top: 16px;
      font-size: 16px;
    }
    span {
      display: block;
      margin-top: 4px;
      color: var(--ink-2);
      font-size: 13.5px;
      line-height: 1.7;
    }
  }
}

/* 兼容 */
.two {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.panel {
  padding: 30px;
  h3 {
    margin-bottom: 10px;
    font-size: 19px;
  }
}
.kv {
  div {
    display: grid;
    grid-template-columns: 112px 1fr;
    gap: 16px;
    padding: 12px 0;
    border-top: 1px solid var(--line);
  }
  dt {
    color: var(--ink-3);
    font-size: 14px;
  }
  dd {
    color: var(--ink);
    font-size: 14px;
  }
  em {
    display: inline-block;
    margin-right: 10px;
    padding: 0 8px;
    font-size: 12px;
    line-height: 20px;
    &.ok {
      color: #6fd69a;
      background: rgba(111, 214, 154, 0.12);
    }
    &.warn {
      color: #f0b34a;
      background: rgba(240, 179, 74, 0.13);
    }
  }
}

/* 敬请期待 */
.soon {
  position: relative;
  overflow: hidden;
  padding: 150px 0;
  background: #070a0b;
  border-top: 1px solid var(--line);
  &__art {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 60%;
    background: url("/static/img/sim/cube.jpg") 50% 42% / cover no-repeat;
    -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 55%);
    mask-image: linear-gradient(90deg, transparent 0, #000 55%);
  }
  &__in {
    position: relative;
    small {
      color: var(--ac);
      font-size: 12px;
      letter-spacing: 4px;
    }
    h2 {
      margin-top: 8px;
      font-size: 52px;
      line-height: 1.2;
      font-weight: 700;
      letter-spacing: 2px;
    }
    p {
      margin: 16px 0 36px;
      max-width: 460px;
      color: var(--ink-2);
    }
  }
  &__btns {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
  }
}

/* FAQ */
.faq {
  details {
    border-bottom: 1px solid var(--line);
    &:first-child {
      border-top: 1px solid var(--line);
    }
  }
  summary {
    position: relative;
    padding: 20px 36px 20px 0;
    font-size: 16.5px;
    font-weight: 600;
    cursor: pointer;
    list-style: none;
    transition: color 0.2s;
    &::-webkit-details-marker {
      display: none;
    }
    &::after {
      content: "+";
      position: absolute;
      right: 4px;
      top: 15px;
      color: var(--ac);
      font-size: 24px;
      font-weight: 300;
    }
    &:hover {
      color: var(--ac-2);
    }
  }
  details[open] summary::after {
    content: "−";
  }
  p {
    padding: 0 36px 22px 0;
    color: var(--ink-2);
  }
}

/* 页脚 */
.foot {
  padding: 44px 0 52px;
  background: #242424;
  &__in {
    img {
      height: 26px;
      width: auto;
      display: block;
    }
    p {
      margin-top: 14px;
      color: #a9b0b1;
      font-size: 14px;
    }
  }
  &__small {
    margin-top: 6px !important;
    color: #777 !important;
    font-size: 12px !important;
  }
}

/* ---------- 入场 ---------- */
.rv {
  opacity: 0;
  transform: translateY(18px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}
.rv--in {
  opacity: 1;
  transform: none;
}
@media (prefers-reduced-motion: reduce) {
  .hero__art,
  .hero__glow,
  .link__line u,
  .flow__track u {
    animation: none;
  }
}

/* ---------- 响应式 ---------- */
@media (max-width: 1040px) {
  .pf {
    grid-template-columns: repeat(2, 1fr);
  }
  .feat {
    grid-template-columns: repeat(2, 1fr);
  }
  .tabs__grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .flow {
    grid-template-columns: repeat(4, 1fr);
    &__track {
      display: none;
    }
  }
  .tiers {
    flex-wrap: wrap;
    > i {
      display: none;
    }
    .tier {
      flex: 1 1 calc(50% - 10px);
    }
  }
  .nav__links {
    display: none;
  }
  .nav__dl {
    margin-left: auto;
  }
}
@media (max-width: 820px) {
  .hero {
    &__art {
      width: 100%;
      opacity: 0.55;
      -webkit-mask-image: linear-gradient(0deg, transparent 0, #000 40%);
      mask-image: linear-gradient(0deg, transparent 0, #000 40%);
    }
    &__glow {
      left: 62%;
      top: 38%;
    }
    h1 {
      font-size: 48px;
    }
    &__sub {
      font-size: 20px;
    }
    &__bar {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .pillar:nth-child(3) {
    border-left: 0;
  }
  .pillar:nth-child(n + 3) {
    border-top: 1px solid var(--line);
  }
  .bento {
    grid-template-columns: 1fr;
    .card {
      grid-column: auto !important;
    }
  }
  .plate {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .two {
    grid-template-columns: 1fr;
  }
  .sec {
    padding: 80px 0;
  }
  .soon {
    padding: 100px 0;
    &__art {
      width: 100%;
      opacity: 0.45;
    }
    &__in h2 {
      font-size: 38px;
    }
  }
}
@media (max-width: 600px) {
  .wrap {
    padding: 0 18px;
  }
  .nav__dl {
    display: none;
  }
  .pf,
  .feat,
  .tabs__grid {
    grid-template-columns: 1fr;
  }
  .flow {
    grid-template-columns: repeat(2, 1fr);
  }
  .tiers .tier {
    flex-basis: 100%;
  }
  .kv div {
    grid-template-columns: 1fr;
    gap: 2px;
  }
  .sec__head h2 {
    font-size: 30px;
  }
}
</style>
